import { ItemExtensionError, IValidationError, ValidationSubject } from './IValidationError';
import { I18nService } from '@lib/i18n';
import { marker } from '@colsen1991/ngx-translate-extract-marker';

export interface IClassificationValidationError extends IValidationError {
    message: string;
    itemId: string;
}

export class ClassificationValidationError extends ItemExtensionError {
    public static isClassificationValidationError(subject: ValidationSubject): boolean {
        return subject === ValidationSubject.CLASSIFICATION;
    }

    public readonly itemId: string;
    public readonly _originalMessage: string;
    public readonly subject: ValidationSubject = ValidationSubject.CLASSIFICATION;

    public get message(): string {
        const message = marker('Die Angabe eine Klassifikation ist pflicht.');
        return this.i18n.translateInstant(message);
    }

    constructor(
        dto: IClassificationValidationError,
        private readonly i18n: I18nService,
    ) {
        super();
        this._originalMessage = dto.message;
        this.itemId = dto.itemId;
    }
}
